import {
  Tooltip as BaseTooltip,
  type TooltipProps as BaseTooltipProps,
} from "@netlify/ui";
import React from "react";

const mapTypeToIntent = (
  type: Exclude<TooltipProps["type"], undefined>,
): BaseTooltipProps["intent"] => {
  switch (type) {
    case "warn":
      return "warning";
    case "info":
    case "error":
      return type;
  }
};

export type TooltipProps = {
  children?: React.ReactNode | undefined;
  className?: string | undefined;
  contents?: React.ReactNode | undefined;
  disabled?: boolean | undefined;
  id?: string | undefined;
  type?: "error" | "info" | "warn";
};

export const Tooltip = ({
  children,
  contents,
  type,
  ...otherProps
}: TooltipProps) => (
  <BaseTooltip
    description={contents}
    intent={type !== undefined ? mapTypeToIntent(type) : undefined}
    {...otherProps}
  >
    {/* @ts-expect-error XXX(ndhoule): BaseTooltipProps.children type is incorrect */}
    {children}
  </BaseTooltip>
);
